import React from "react";
import TabbedPage from "../../../../Elements/TabbedPage";
import OverWindow from "../../../../Elements/TabList/OverWindow";
import PendingApprovalTab from "./PendingApprovalTab";
import AllPaymentsTab from "./AllPaymentsTab";

export default class ShowAssignmentAssignmentPaymentsOverDataWindow extends React.Component {
  static defaultProps = {
    assignment: {},
    clickOnCancel: () => {
      alert("Missing function");
    },
  };

  tabs = [
    {
      label: "All Payments",
      id: "allpayments",
      icon: "fa-solid fa-memo-circle-info",
      component: (
        <AllPaymentsTab
          assignment={this.props.assignment}
          ieAsId={this.props.assignment.asId}
          newButtonsEnabled={true}
        />
      ),
    },
    {
      label: "Pending Payments",
      id: "pendingapproval",
      icon: "fa-solid fa-memo-circle-info",
      component: (
        <PendingApprovalTab
          assignment={this.props.assignment}
          ieAsId={this.props.assignment.asId}
          newButtonsEnabled={true}
        />
      ),
    },
  ];

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={`Assignment Payments (SassieId: ${this.props.assignment.asSassieAsgnId})`}
        closeOnClickOutside={false}
      >
        <div className="verticalScroll showassignmentlistheight">
          <TabbedPage tabs={this.tabs} />
        </div>
      </OverWindow>
    );
  }
}
